<template>

    <div class="page-static-container">

        <header-static v-if="!isNativeUser"></header-static>

        <article class="page-static-text-container" v-html="html"></article>

        <footer-landing v-if="!isNativeUser"></footer-landing>

        <link rel="stylesheet" type="text/css" href="/static/css/style.css">

    </div>

</template>

<script>

import Vuex from 'vuex'

import I18n from '@/modules/i18n'
import Update from '@/modules/update'
import UserFlow from '@/modules/userFlow'

import HeaderStatic from '@/components/headers/HeaderStatic'
import FooterLanding from '@/components/FooterLanding'

export default {

    name: 'terms',

    components: { HeaderStatic, FooterLanding },

    watch: {

        lang: function () {
            this.loadContent()
        }

    },

    computed: {

        ...Vuex.mapGetters(['lang']),

        isNativeUser: function () {
            return this.$route.path.indexOf('/native/') > -1
        }
    },

    data () {
        return {
            html: ''
        }
    },

    created () {
        UserFlow.setPage(this, 'terms')
    },

    mounted () {

        this.loadContent()

        Update.terms.accept()

    },

    methods: {

        loadContent() {

            this.$http.get(`/static/terms/${I18n.get(this)}.html`).then(response => {
                this.html = response.data
            })
        }

    }
}
</script>

<style scoped lang="scss"></style>
